export const getInitials = (fullName: string) => {
  if (!fullName) return '';
  
  return fullName
    .split(' ')
    .map((name: string) => name[0])
    .join('')
    .toUpperCase();
};